import React, { useEffect } from 'react';
import classNames from 'classnames';

import { Input } from '@ps-design-system/components/Input';

import CreditCardSelect from './CreditCardSelect';
import { useStripeElements } from './utils';

// Renders stripe payment element form and credit card select
const PaymentElement = ({
  onCardChange,
  showStripeElement,
  error,
  cards,
  selectedCard,
  cardHoldersInputProps
}) => {
  const { elements } = useStripeElements();

  useEffect(() => {
    return () => {
      elements?.getElement?.('payment')?.destroy();
    }
  }, [elements]);

  // Initialize stripe payment elements
  useEffect(() => {
    if (elements) {
      try {
        elements?.getElement?.('payment')?.destroy();
        const paymentElement = elements?.create?.('payment', {
          terms: {
            card: 'never'
          },
          wallets: {
            googlePay: 'never',
            applePay: 'never'
          }
        });
        paymentElement?.mount?.('#payment-element');
      } catch (e) {
        console.log('#Error when creating a stripe element', e);
      }
    }
  }, [elements]);

  return (
    <div className="flex column tw-gap-16">
      <CreditCardSelect
        cards={cards}
        selectedCard={selectedCard}
        setSelectedCard={onCardChange}
      />
      <div className={classNames('flex column tw-gap-16', { hidden: !showStripeElement })}>
        <div className="flex column">
          <Input
            placeholder="Cardholders name"
            fullWidth
            data-testing-id="cardholder-name-input"
            {...cardHoldersInputProps}
          />
          {error && <div className="help-block inline-help text-danger">{error}</div>}
        </div>
        <div id="payment-element" />
      </div>
    </div>
  );
};

export default PaymentElement;